/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LibraryOriginOut } from './libraryOriginOut';
import type { ScorecardDefinitionOutSelectionRule } from './scorecardDefinitionOutSelectionRule';
import type { ScorecardVersionOut } from './scorecardVersionOut';

export interface ScorecardDefinitionOut {
  id: string;
  org_id: string;
  job_id: string | null;
  name: string;
  /** Order within the active set (0..n-1). Meaningful for active rows only; archived rows' position is unspecified and must not be sorted by. */
  position: number;
  is_default: boolean;
  archived_at: string | null;
  selection_rule: ScorecardDefinitionOutSelectionRule;
  current_version: ScorecardVersionOut;
  library_origin: LibraryOriginOut | null;
  library_update_available: boolean;
  library_customized: boolean;
  used_by_jobs?: number | null;
  updated_at: string;
}
